"use strict";

require("@patsnap-biz/icon/lib/style");
require("./toast.scss");